import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {DepositHeaderButtonBox} from './boxes/deposit-header-button.box';
import {AreaType} from '@sparkware/uc-sdk-core';
import {CHANNEL_SOURCE, CHANNEL_ELEMENTS} from '../../../../../common/const/casinofied-analytics-consts';
import {Image} from '../../../raw-components/image/image';

export class DepositHeaderButtonComponent extends OrbitComponent {
    private onClick = () => {
        this.services.cashier.openDeposit({
            channel: {
                source: CHANNEL_SOURCE.casinoClient,
                area: AreaType.UserArea,
                element: CHANNEL_ELEMENTS.depositButton
            }
        });
    };
    render() {
        return <DepositHeaderButtonBox onClick={this.onClick}>
            <Image src={this.services.theme.currentTheme.images.depositHeaderIcon.toString()} />
        </DepositHeaderButtonBox>;
    }
}